<script setup>
import { computed, ref } from 'vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';

import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

const store = useStore();
const getters = useStoreGetters();
const { t } = useI18n();

const automation = ref({});
const dialogRef = ref(null);
const uiFlags = getters['wgptAutomations/getUIFlags'];

const description = computed(() => {
  return `${t('WGPT_AUTOMATIONS.DELETE.CONFIRM.MESSAGE')} ${automation.value.name}?`;
});

const deleteConfirmText = computed(
  () => `${t('WGPT_AUTOMATIONS.DELETE.CONFIRM.YES')}`
);

const deleteRejectText = computed(
  () => `${t('WGPT_AUTOMATIONS.DELETE.CONFIRM.NO')}`
);

const handleDialogConfirm = async () => {
  const id = automation.value.id;
  if (!id) return;

  try {
    await store.dispatch('wgptAutomations/delete', id);
    useAlert(t('WGPT_AUTOMATIONS.DELETE.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('WGPT_AUTOMATIONS.DELETE.API.ERROR_MESSAGE'));
  } finally {
    dialogRef.value?.close();
  }
};

const open = selectedAutomation => {
  automation.value = selectedAutomation;
  dialogRef.value?.open();
};

defineExpose({ open });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('WGPT_AUTOMATIONS.DELETE.CONFIRM.TITLE')"
    :description="description"
    :confirm-button-label="deleteConfirmText"
    :cancel-button-label="deleteRejectText"
    :is-loading="uiFlags.isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
